$mol_icon_align_vertical_top $mol_icon path \M22 2V4H2V2H22M7 22H10V6H7V22M14 16H17V6H14V16Z
